import React from 'react';
import * as PropTypes from 'prop-types';
import Link from '../../atoms/Link';
import LogosBrand from '../../assets/logos/LogosBrand/LogosBrand';
import { ArrowLeftIcon } from 'icons/solid';

const HeaderBlog = ({ blogUrl, storeUrl }) => {
    return (
        <div className='sticky z-10 w-full shadow-down'>
            <header>
                <div className='container md:py-2'>
                    <div className='relative flex items-center'>
                        <div className='flex w-full items-center justify-between p-2 lg:block'>
                            <Link
                                className='flex flex-col items-start md:items-center'
                                underline={false}
                                label='Home'
                                href={blogUrl}
                            >
                                <>
                                    <LogosBrand
                                        type='mundo_y'
                                        className='my-2 inline-block w-40 lg:my-0 lg:w-48'
                                    />
                                    <h4 className='my-2'>Blog</h4>
                                </>
                            </Link>
                        </div>
                        <Link
                            className='relative right-0 flex md:absolute'
                            underline={false}
                            href={storeUrl}
                        >
                            <>
                                <ArrowLeftIcon className='mr-2 h-[14px] w-[14px]' />
                                <h6 className='-mt-1 md:pt-2'>Regresar a la tienda</h6>
                            </>
                        </Link>
                    </div>
                </div>
            </header>
        </div>
    );
};

HeaderBlog.displayName = 'HeaderBlog';

HeaderBlog.defaultProps = {};

HeaderBlog.propTypes = {
    blogUrl: PropTypes.string.isRequired,
};

export default HeaderBlog;
